// eslint-disable-next-line import/no-cycle
import withHttp from '@/config/withHttp';
var baseURL = '/judgeagent';
/* *************** 庭审中相关接口 ******************* */

var apis = {
  getDictList: {
    url: '/case/dictList',
    method: 'get'
  },
  // 获取当前项目类型（区分仲裁和审判）
  getCommonInfo: {
    url: '/common/getCommonInfo',
    method: 'get'
  }
};
export default withHttp(apis, baseURL);